const navItems = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Funcionalidades', href: '#funcionalidades' },
  { label: 'Instituciones', href: '#instituciones' },
  { label: 'Licencias', href: '#licencias' },
  { label: 'Contacto', href: '#contacto' }
];

export function Navbar() {
  return (
    <header className="container-base relative z-20 pt-6">
      <div className="flex flex-col gap-3 rounded-3xl border border-white/80 bg-white/90 px-4 py-3 shadow-soft backdrop-blur sm:flex-row sm:items-center sm:justify-between sm:rounded-full sm:py-2.5">
        <a href="#inicio" className="mx-auto sm:mx-0" aria-label="+Trainer Inicio">
          <img src="/navbar_logo.png" alt="+Trainer" className="h-8 w-auto sm:h-10" />
        </a>
        <nav className="overflow-x-auto">
          <ul className="flex min-w-max items-center justify-center gap-1.5 sm:gap-2">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="inline-flex rounded-full px-3 py-1.5 text-xs font-semibold text-slate-600 transition-colors hover:bg-brand-50 hover:text-brand-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 sm:text-sm"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
